import React, {Fragment} from 'react'
import { graphql, StaticQuery } from 'gatsby'


class Hero extends React.Component{
    constructor(props){
        super(props)
    }

    render(){
    const {headerBackBlue} = this.props.query;
        return(
            <Fragment>
                <section className="om-albert-banner static-banner" style={{background: `url(${headerBackBlue.publicURL})`}}>
                    <div className="custom-container">
                        <div className="content-img">
                            <div className="col-lg-12 col-sm-12 col-md-12 col-xs-12">
                                <div className="row">
                                    <h3>Bättre kunskap i matematik.</h3>	
                                    <p className="desktop">Med ny teknik vill Albert vill höja kunskapsnivåerna för alla – <br/> oavsett elevens förutsättningar.</p>
                                    <p className="for-mobile">Med ny teknik vill Albert vill höja <br/> kunskapsnivåerna för alla – <br/> oavsett elevens förutsättningar.</p>
                                </div>
                            </div>
                        </div>
                        </div>
                    </section>
                    <section className="text-middle">
                        <div className="custom-container">
                            <div className="col-md-6 col-sm-6 col-xs-12">
                                <h3 className="desktop">Enligt skolverket fick en stor andel av <br/> Sveriges tredjeklassare underkänt i <br/> matematik under nationella proven. <br/> År 2018 fick över 50 % av alla <br/> gymnasieelever på gymnasiet som <br/> skrev nationella provet i matte <br/> 2b underkänt.</h3>
                                <h3 className="for-mobile">Enligt skolverket fick en stor andel <br/> av Sveriges tredjeklassare <br/> underkänt i matematik under <br/> nationella proven. År 2018 fick över <br/> 50 % av alla gymnasieelever på <br/> gymnasiet som skrev nationella <br/> provet i matte 2b underkänt.</h3>
                            </div>
                            <div className="col-md-6 col-sm-6 col-xs-12">
                                <p className="desktop">Albert vill vända den negativa skoltrenden genom att <br/> göra plugget roligare, mer engagerande och bättre <br/> anpassat efter individen. Målet är att tillgängliggöra <br/> kunskapsspridning med hjälp av teknik och på så <br/> sätt hjälpa alla elever i Sverige att uppnå högre <br/> betyg och höjda kunskapsnivåer.</p>
                                <p className="desktop">Vi består av ett ungt och entreprenörsdrivet team med <br/> ambitionen att göra Albert till den självklara digitala <br/> aktören för barns lärande. I dagsläget har över 150.000 <br/> elever valt Albert som digital mattelärare, en siffra som <br/> stiger för varje vecka.</p>
                                
                                <p className="for-mobile">Albert vill vända den negativa skoltrenden genom att <br/> göra plugget roligare, mer engagerande och <br/> bättre anpassat efter individen. Målet är att <br/> tillgängliggöra kunskapsspridning med hjälp av teknik <br/> och på så sätt hjälpa alla elever i Sverige att <br/> uppnå högre betyg och höjda kunskapsnivåer.</p>
                                <p className="for-mobile">Vi består av ett ungt och entreprenörsdrivet team med <br/> ambitionen att göra Albert till den självklara <br/> digitala aktören för barns lärande. I dagsläget har <br/> över 150.000 elever valt Albert som digital <br/> mattelärare, en siffra som stiger för varje vecka.</p>                                
                            </div>
                        </div>
                    </section>
            </Fragment>
        )
    }
}

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    headerBackBlue: file(relativePath: {regex: "/plain-background/"}) {
                        publicURL
                    }
                }`
            }
        render={(data)  => (
           <Hero query={data} {...props}/>
        )}
    />
)